import { Directive } from "@angular/core";
import { BaseComponent, UserService } from "@mypxplat/xplat/core";

@Directive()
export abstract class TermsofuseBaseComponent extends BaseComponent {
  public text: string = "Termsofuse";

  constructor(userService: UserService) {
    super(userService);
  }
}
